import axios from 'axios'
import router from '@/router'

export default () => {
     
    const headers = {
        'Content-Type': 'multipart/form-data'
    }
    const instance = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        withCredentials: false,
        headers

    })   

    instance.interceptors.response.use(null, function(error) {
        if(!error.response || error.response.status === 401) {
            localStorage.getItem('token')
            router.replace('/login')
        }
        return Promise.reject(error)
    })

    return instance
}